import React from 'react';
import { NavLink } from "react-router-dom";
import { portalNavPillActive, portalNavPillBase } from "../../theme/portalLayout";

interface Props {
  route: string;
  title: string;
  icon: string;
  activeIcon: string;
  visible?: boolean;
}

function NavBarItem({route, title, icon, activeIcon: _activeIcon, visible = true}: Props) {
  return (
    <li className={visible ? "" : "hidden"}>
      <NavLink
        to={route}
        className={({isActive}) =>
          isActive
            ? `${portalNavPillActive} hover:bg-portal-nav-active`
            : `${portalNavPillBase} hover:bg-super-light-grey`
        }
        children={() => (
          <>
            <img
              src={icon}
              alt=""
              className="hidden sm:block sm:mr-md sm:h-md sm:mt-1 sm:flex-shrink-0"
              aria-hidden="true"
            />
            {title}
          </>
        )}
      />
    </li>
  );
}

export default NavBarItem;